<template>
    <div class="drag_guide" v-if="isShow" :style="styleString"/>
</template>


<script>
import { timeHeight, TIME_TOP_MARGIN } from './time-height'
export default {
    props: {
        scroll: HTMLDivElement,
    },
    data() {
        return {
            timeHeight
        }
    },
    computed: {
        isShow: function() {
            return this.timeHeight.isResizing
        },
        topMargin: function() {
            let top = this.scroll?.scrollTop
            return top + this.timeHeight.guideY - 6 - TIME_TOP_MARGIN
        },
        styleString: function() {
            return 'top: ' + this.topMargin + 'px;'
        }
    },
}
</script>

<style scoped>
    .drag_guide{
        position: absolute;
        width: 100vw;
        height: 1px;
        background-color:var(--gray80);
        z-index: 100;
    }
</style>